import {
  MAX_NAME_LENGTH,
  MAX_PROJECT_ACRONYM_LENGTH,
  MAX_PROJECT_DESCRIPTION_LENGTH,
} from "../CreateProjectForm";

import { z } from "zod/v3";

export const editProjectSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "Name is required")
    .max(MAX_NAME_LENGTH, `Name must be at most ${MAX_NAME_LENGTH} characters`),

  acronym: z
    .string()
    .trim()
    .max(
      MAX_PROJECT_ACRONYM_LENGTH,
      `Acronym must be at most ${MAX_PROJECT_ACRONYM_LENGTH} characters`,
    )
    .transform((value) => value.toUpperCase() || undefined),

  area: z.preprocess(
    (value) => {
      if (
        value === "" ||
        value === null ||
        value === undefined ||
        (typeof value === "number" && Number.isNaN(value))
      ) {
        return undefined;
      }

      return value;
    },
    z.coerce
      .number({
        invalid_type_error: "Area must be a number",
      })
      .positive("Area must be greater than zero")
      .optional(),
  ),

  description: z
    .string()
    .max(
      MAX_PROJECT_DESCRIPTION_LENGTH,
      `Description must be at most ${MAX_PROJECT_DESCRIPTION_LENGTH} characters`,
    )
    .optional()
    .or(z.literal("")),

  imageId: z.string().optional(),
});

export type EditProjectFormInput = z.input<typeof editProjectSchema>;
export type EditProjectFormData = z.output<typeof editProjectSchema>;
